export class Environment {

    public static isLocal() {
        try {
            return window.top === window.self && /\/\/(localhost)|(127\.0\.0\.1)/.test(window.location.href);
        } catch (e) {
            // ignore
        }
        return false;
    }

    public static isInternal() {
        try {
            return window.top === window.self && /\/internal/.test(window.location.href);
        } catch (e) {
            // ignore
        }
        return false;
    }

    public static isLive() {
        return !this.isLocal() && !this.isInternal();
    }

    public static isBPS() {
        return /packageName=org\.pbskids\.gamesapp/.test(window.location.search);
    }
}
